import { parseDate } from '@artup/utilities'
import { Assignable } from '../common'
import { PaymentStatus } from './payment-status'

/**
 * Payment details
 */
export class Payment extends Assignable {
  constructor (data = {}) {
    super()
    this.assign(data, {
      updatedAt: parseDate
    })
  }

  normalize () {
    super.normalize()
    this.updatedAt = this.updatedAt || new Date()
  }

  /**
   * Payment identifier
   * @type {String}
   */
  id

  /**
   * Order identifier
   * @type {String}
   */
  orderId

  /**
   * Payment provider identifier
   * @type {PaymentProviders}
   */
  provider

  /**
   * Payment session identifier in the payment provider's system
   * @type {String}
   */
  sessionId

  /**
   * Payment session details, provider-specific
   * @type {Object}
   */
  session

  /**
   * Date and time of the most recent update of the payment
   * @type {Date}
   */
  updatedAt

  /**
   * Payment status
   * @type {PaymentStatus }
   */
  status

  /**
   * More details about the current {@link status}
   * @type {String[]}
   */
  details

  /**
   * Checks whether the payment hasn't yet been started
   * @type {Boolean}
   */
  get isNotStarted () {
    return !this.status
  }

  /**
   * Checks whether the payment is now in progress
   * @type {Boolean}
   */
  get inProgress () {
    return this.status === PaymentStatus.Initiated
  }

  /**
   * Checks whether the payment has been completed
   * @type {Boolean}
   */
  get isCompleted () {
    return this.status === PaymentStatus.Completed
  }

  /**
   * Checks whether the payment has failed
   * @type {Boolean}
   */
  get wasCancelled () {
    return this.status === PaymentStatus.Cancelled
  }

  /**
   * Checks whether the payment has ended with unexpected error
   * @type {Boolean}
   */
  get isError () {
    return this.status === PaymentStatus.Error
  }

  toJSON () {
    const result = { ...this }
    delete result.order
    return result
  }
}
